import './PaperlessPreferenceSection.scss';
import React, { Fragment } from 'react';

const PaperlessPreferenceSection = ({ accountsSectionTitle, children }) => {
  return (
    <div className="paperless-accounts-section-header">
      <span className="title">{accountsSectionTitle}</span>
      <span className="section-title">Document</span>
      <Fragment>{children}</Fragment>
    </div>
  );
};

export default PaperlessPreferenceSection;
